import { useMemo } from 'react';
import { connect } from 'react-redux';
import { Button, Box } from '@mui/material';
import { useMaterialReactTable, MaterialReactTable } from 'material-react-table';
import { arraysEqual } from '../../../../utils/collections';
import { tableSelectionOptions, defaultTableOptions } from '../../../util/data-table';
import {
  equipmentFeedsCol,
  equipmentFeedsId,
  equipmentColumns,
  equipmentNameId,
  lastPublishedCol,
  equipmentTypeId,
  enrichColHeaderWithTooltip,
  enrichColAccessorFnWithMissing,
} from '../../columns';
import { createFeeds, deleteFeeds } from '../../../../redux/actions/buildings';

const FeedsEquipment = ({
  stagingEquipment,
  equipment,

  equipmentTypes,
  feedsCreate,
  feedsDelete,
}) => {
  const columns = useMemo(
    () => [
      enrichColAccessorFnWithMissing(enrichColHeaderWithTooltip(equipmentFeedsCol(equipment))),
      ...equipmentColumns(false, equipmentTypes),
    ],
    [equipmentTypes, equipment]
  );
  const data = useMemo(
    // Default order selected first
    () =>
      stagingEquipment
        .filter((e) => Boolean(e.published))
        .filter((e) => e.equipId !== equipment.equipId)
        .sort((a, b) => {
          if (a.published?.fedByEquipment?.includes(equipment.published.id)) {
            if (b.published?.fedByEquipment?.includes(equipment.published.id)) {
              return a.id < b.id;
            }
            return -1;
          }
          if (b.published?.fedByEquipment?.includes(equipment.published.id)) return 1;
          return a.id < b.id;
        }),
    [stagingEquipment, equipment]
  );

  const mrt = useMaterialReactTable({
    ...defaultTableOptions,
    ...tableSelectionOptions,
    columns,
    data,
    initialState: {
      showColumnFilters: true,
      columnVisibility: Object.fromEntries(
        columns
          .map((c) => c.id)
          .filter(
            (id) =>
              ![equipmentFeedsId, equipmentNameId, equipmentTypeId, lastPublishedCol.id].includes(
                id
              )
          )
          .map((id) => [id, false])
      ),
      rowSelection: Object.fromEntries(equipment.published?.feedsEquipment.map((id) => [id, true])),
    },
    getRowId: (e) => e.published.id,
    renderTopToolbarCustomActions: ({ table }) => {
      const handleApply = () => {
        const selectedIds = table
          .getSelectedRowModel()
          .flatRows.map(({ original }) => original.published.id);
        function handleRemove() {
          const equipmentToRemove = equipment.published.feedsEquipment.filter(
            (l) => !selectedIds.includes(l)
          );
          if (equipmentToRemove.length > 0) return feedsDelete(equipmentToRemove);
          return Promise.resolve();
        }
        function handleAdd() {
          const equipmentToAdd = selectedIds.filter(
            (l) => !equipment.published.feedsEquipment.includes(l)
          );
          if (equipmentToAdd.length > 0) return feedsCreate(equipmentToAdd);
          return Promise.resolve();
        }
        return handleRemove().then(() => handleAdd());
      };

      return (
        <Box sx={{ display: 'flex', gap: '0.5rem' }}>
          <Button
            color="success"
            disabled={arraysEqual(
              table
                .getSelectedRowModel()
                .flatRows.map(({ original }) => original.published.id)
                .toSorted(),
              equipment.published.feedsEquipment
            )}
            onClick={handleApply}
            variant="contained"
          >
            Apply Selection
          </Button>
        </Box>
      );
    },
  });
  return <MaterialReactTable table={mrt} />;
};

function mapStateToProps(state) {
  const {
    entities: { equipTypes },
  } = state;
  return {
    equipmentTypes: equipTypes.byId,
  };
}

function mapDispatchToProps(dispatch, { equipment, building }) {
  return {
    feedsCreate: (newFeedsEquipment) =>
      dispatch(createFeeds(building.id, equipment.publishedEquipmentId, [], newFeedsEquipment)),
    feedsDelete: (feedsEquipmentToRemove) =>
      dispatch(
        deleteFeeds(building.id, equipment.publishedEquipmentId, [], feedsEquipmentToRemove)
      ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(FeedsEquipment);
